
import Note1 from "../../../assets/duotone/Note1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Note1Icon({ className, dataTestid = "Note1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Note1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
